// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file entity/contact.proto (package entity, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { ContactType } from "../consts/constant_pb";

/**
 * Contact構造体
 *
 * @generated from message entity.Contact
 */
export class Contact extends Message<Contact> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: constant.ContactType contact_type = 2 [json_name = "contact_type"];
   */
  contactType = ContactType.NONE;

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: string email = 4;
   */
  email = "";

  /**
   * @generated from field: string subject = 5;
   */
  subject = "";

  /**
   * @generated from field: string message = 6;
   */
  message = "";

  /**
   * @generated from field: string phone = 7;
   */
  phone = "";

  /**
   * @generated from field: bool is_read = 8 [json_name = "is_read"];
   */
  isRead = false;

  /**
   * @generated from field: google.protobuf.Timestamp read_at = 9 [json_name = "read_at"];
   */
  readAt?: Timestamp;

  /**
   * @generated from field: string environment = 10;
   */
  environment = "";

  /**
   * @generated from field: google.protobuf.Timestamp create_date = 11 [json_name = "create_date"];
   */
  createDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp update_date = 12 [json_name = "update_date"];
   */
  updateDate?: Timestamp;

  /**
   * @generated from field: string version = 13;
   */
  version = "";

  constructor(data?: PartialMessage<Contact>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "entity.Contact";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "contact_type", jsonName: "contact_type", kind: "enum", T: proto3.getEnumType(ContactType) },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "is_read", jsonName: "is_read", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "read_at", jsonName: "read_at", kind: "message", T: Timestamp },
    { no: 10, name: "environment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "create_date", jsonName: "create_date", kind: "message", T: Timestamp },
    { no: 12, name: "update_date", jsonName: "update_date", kind: "message", T: Timestamp },
    { no: 13, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Contact {
    return new Contact().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Contact {
    return new Contact().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Contact {
    return new Contact().fromJsonString(jsonString, options);
  }

  static equals(a: Contact | PlainMessage<Contact> | undefined, b: Contact | PlainMessage<Contact> | undefined): boolean {
    return proto3.util.equals(Contact, a, b);
  }
}

